import Button2 from "../../../Button/Button2";
import ListOption from "../EditAutomations/ListOption";
import { RuleProvider, useRule } from "./RuleReducer";
import classes from '../CreateRule/SelectOutputs.module.css'
import { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";

const ChooseWhat = ({navigate, createRule}) => {

    const { state, dispatch } = useRule(RuleProvider);
    // let finished = false;
    const [progress, setProgress] = useState(100)
    const [finished, setFinished] = useState(true)

    //let finished = true

    const [matchButtonText, setMatchButtonText] = useState("Match the state")
    const [oppposeButtonText, setOpposeButtonText] = useState("Oppose the state")
    const [toggleButtonText, setToggleButtonText] = useState("Toggle state")
    
    const HandleText = () => {
        let inputType;
        let inputRule;
        switch (state.inputType) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                break;
            case 1: 
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily arm"
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily disarm"
                break;
            default:
                inputType = "unknown";
                break;
        }

        
        switch (state.inputRule) {
            case 0:
                if (state.isLock){
                    inputRule = `will be disarmed`;
                } else {
                    inputRule = `will match ${state.pinName} state`;
                }
                
                break;
            case 1: 
                if (state.isLock){
                    inputRule = `will be armed`;
                } else {
                    inputRule = `will oppose ${state.pinName} state`;
                }
                break;
            case 2:
                if (state.isLock) {
                    inputRule = "will toggle state"
                } else {
                    inputRule = `will toggle`;
                }
                
                break;
        }

        if (state.isLock){
            inputType = "opened"
        }

        
        return `When ${state.pinName} is ${inputType}, ${state.selectedPinsToAffect.map(pin => pin.pinName).join(", ")} ${inputRule}`;
    }

    useEffect(() => {
        if (state.isLock){
            setMatchButtonText("Disarm")
            setOpposeButtonText("Arm")
            setToggleButtonText("Toggle state")
        }
    }, [])

    const HandleInputRuleSelected = (selection, value) => {
        console.log(selection)
        //finished = value
        //issue here - navigates to timer screen no matter the selection
         if (selection == 0 || selection == 1 || selection == 2){
            dispatch({type: "SET_INPUT_RULE", payload: selection})
            console.log("here")
            
            setFinished(true)
            setProgress(100)
            //save
        } else {
            console.log("here")
           dispatch({type: "SET_INPUT_TYPE", payload: selection})
           dispatch({type: "SET_INPUT_RULE", payload: 10})
           setFinished(false)
           setProgress(80)
           //go to timer 
       }   
    }


    const HandleNavigate = (direction) => {
        if (direction === "back") {
            navigate(2);
            return;
        } else {
            if (finished) {
                createRule(state.inputRule, state.selectedPinsToAffect)
            } else {
                navigate(4);
            }
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
            <ProgressBar progress={progress} />
            <div style={{display: "flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between", gap: "20px"}}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                <ListOption optionText={HandleText()} propsClassName={classes.infoBox} />
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            <h3 style={{ color:"#6e6e6e"}}>Which state should the switches change to when the rule triggers?</h3>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                <Button2 style={{ 
                                 minWidth: "350px", 
                                 minHeight:"50px", 
                                backgroundColor: state.inputRule == 0 && 
                                "var(--Primary-Color)", color: state.inputRule == 0 && 
                                "white", 
                                border: state.inputRule == 0 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }  
                            onClick={() => HandleInputRuleSelected(0, true)}>{matchButtonText}</Button2>
                <Button2 style={{ 
                                 minWidth: "350px", 
                                 minHeight:"50px", 
                                backgroundColor: state.inputRule == 1 && 
                                "var(--Primary-Color)", color: state.inputRule == 1 && 
                                "white", 
                                border: state.inputRule == 1 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }  
                            onClick={() => HandleInputRuleSelected(1, true)}>{oppposeButtonText}</Button2>
                <Button2 style={{ 
                                 minWidth: "350px", 
                                 minHeight:"50px", 
                                backgroundColor: state.inputRule == 2 && 
                                "var(--Primary-Color)", color: state.inputRule == 2 && 
                                "white", 
                                border: state.inputRule == 2 && 
                                "2px solid lightblue", minWidth: "300px"}
                            }  
                            onClick={() => HandleInputRuleSelected(2, true)}>{toggleButtonText}</Button2>

                {((state.supportsOutputPulse || state.supportsInputPulse) && (state.inputTypeCopy == 0) || state.isLock) && (
                    <Button2 style={{ 
                        minWidth: "350px", 
                        minHeight:"50px", 
                        backgroundColor: state.inputType == 3 && 
                        "var(--Primary-Color)", color: state.inputType == 3 && 
                        "white", 
                        border: state.inputType == 3 && 
                        "2px solid lightblue", minWidth: "300px"}
                    }  
                     onClick={() => HandleInputRuleSelected(3, false)}>Temporarily arm</Button2>
                )}
                {((state.supportsOutputPulse || state.supportsInputPulse)) && (state.inputTypeCopy == 0 || state.isLock) && (
                    <Button2 style={{ 
                        minWidth: "350px", 
                        minHeight:"50px",  
                        backgroundColor: state.inputType == 4 && 
                        "var(--Primary-Color)", color: state.inputType == 4 && 
                        "white", 
                        border: state.inputType == 4 && 
                        "2px solid lightblue", minWidth: "300px"}
                    }  
                     onClick={() => HandleInputRuleSelected(4, false)}>Temporarily disarm</Button2>
                )}
            </div>
        </div>
    )
}

export default ChooseWhat;